export default __webpack_public_path__ + "static/media/education_desktop.950d4d4a.webp";